export const GLOBAL_INFO = 'global.GLOBAL_INFO';
export const RESET_GLOBAL_INFO = 'global.RESET_GLOBAL_INFO'